import React, { useState, useEffect } from "react";
import { Button, FormControl, InputLabel, MenuItem, TableRow, Table, TableHead, TableBody, TableCell,
    TableContainer,
              Paper
 } from "@material-ui/core";
import ActivityService from "./Locality/Service/activityService";
import { Grid, Card, Box, Select } from "@material-ui/core";
import StudentService from "./Locality/Service/studentService";
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import AddClassService from "./Locality/Service/addClassService";

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#0f3b62ad",
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
    tableOverflow: {
        overflowX: 'auto',
    },
}));

export default function ReportOfActivities() {
    const tableHeaders = ['Class', 'Student Name', 'Area of Work', 'List of Activities', 'Exercise', 'Remarks', 'Date', 'Key'];
    const classes = useStyles();
    const [activityList, setActivityList] = useState([]);
    const [addClassList, setAddClassList] = useState([]);
    const [studentList, setStudentList] = useState([]);
    const [classId, setClassId] = useState("");
    const [studentId, setStudentId] = useState("");
    const [keyValue, setKeyValue] = useState("");
    const [pg, setPg] = useState(0);
    const [rpg, setRpg] = useState(100);

    useEffect(() => {
        getAddClassList();
        return () => {
            setActivityList([]);
            setAddClassList([]);
            setStudentList([]);
        };
    }, []);

    const getAddClassList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        AddClassService.getAllAddClass(userDetails.schooleId).then((res) => {
            if (userDetails.role === "TEACHER") {
                res = res.filter(res => res._id === userDetails.classId);
            }
            setAddClassList(res);
            if (userDetails.classId) {
                setClassId(userDetails.classId);
                getStudentList(userDetails.classId);
            } else {
                setClassId("");
            }
        }).catch((err) => {});
    };

    const findActivityList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        let mappedKey = keyValue;
        if (keyValue === "A") mappedKey = "Works with Assistance";
        if (keyValue === "I") mappedKey = "Works Independently";
        if (keyValue === "N") mappedKey = "Presented(1)";

        const keys = {
            classId: classId,
            schooleId: userDetails.schooleId,
            studentId: studentId,
            ...(mappedKey && { key: mappedKey })
        };

        console.log("Filter keys:", keys);

        ActivityService.findActivityList(keys).then((res) => {
            console.log("API Response:", res);
            setActivityList(res);
        }).catch((err) => {
            console.error("API Error:", err);
        });
    };

    const getStudentList = (classId) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        StudentService.getAllStudentById(userDetails.schooleId, { classId }).then((res) => {
            const studentDetails = res.map(res => ({
                _id: res._id,
                studentName: `${res.firstName} ${res.lastName}`,
                status: true
            }));
            setStudentList(studentDetails);
        }).catch((err) => {});
    };

    // Filter activityList to only include entries with records
    const filteredActivityList = activityList.filter(activitydetails => 
        activitydetails.activityRecordsId && activitydetails.activityRecordsId.length > 0
    );

    return (
        <>
            <PageTitle title="Activity Reports" />
            <Card sx={{ maxWidth: 345 }}>
                <Box>
                    <Grid container spacing={2} columns={12} style={{ margin: 10 }}>
                        <Grid item xs={3}>
                            <FormControl variant="standard" fullWidth>
                                <InputLabel id="demo-simple-select-standard-label">Class</InputLabel>
                                <Select
                                    labelId="demo-simple-select-standard-label"
                                    id="className"
                                    name="classId"
                                    label="className"
                                    value={classId}
                                    onChange={e => {
                                        setClassId(e.target.value);
                                        getStudentList(e.target.value);
                                    }}
                                >
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                    {addClassList.map(({ _id, className }) => (
                                        <MenuItem key={_id} value={_id}>{className}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                            <FormControl variant="standard" fullWidth>
                                <InputLabel id="studentName">Student Name</InputLabel>
                                <Select
                                    labelId="studentName"
                                    id="studentName"
                                    label="Student Name"
                                    name="studentId"
                                    value={studentId}
                                    onChange={e => setStudentId(e.target.value)}
                                >
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                    {studentList.map(({ _id, studentName }, index) => (
                                        <MenuItem key={index} value={_id}>{studentName}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                            <FormControl variant="standard" fullWidth>
                                <InputLabel id="demo-simple-select-standard-label">Select Key</InputLabel>
                                <Select
                                    labelId="demo-simple-select-standard-label"
                                    id="demo-simple-select-standard"
                                    label="Key"
                                    name="key"
                                    value={keyValue}
                                    onChange={e => setKeyValue(e.target.value)}
                                >
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                    <MenuItem value="A">Works with Assistance</MenuItem>
                                    <MenuItem value="I">Works Independently</MenuItem>
                                    <MenuItem value="N">Presented</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                            <Button
                                style={{ backgroundColor: 'rgb(15 59 98)', color: 'white' }}
                                type="button"
                                onClick={findActivityList}
                                variant="contained"
                            >
                                Search
                            </Button>
                        </Grid>
                        </Grid>
                        </Box>
                        </Card>
                        <Grid container spacing={4}>
                            <Grid item xs={12}>
                                <Widget title="" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
                                                                                                            <TableContainer component={Paper} style={{ maxHeight: 500 }}>
                                    
                                    <Table stickyHeader className="mb-0">
                                        <TableHead>
                                            <TableRow>
                                                {tableHeaders.map(key => (
                                                    <StyledTableCell key={key}>{key}</StyledTableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {filteredActivityList.length > 0 ? (
                                                filteredActivityList.slice(pg * rpg, pg * rpg + rpg).map((activitydetails) =>
                                                    activitydetails.activityRecordsId.map((record) => (
                                                        <TableRow key={record._id}>
                                                            <TableCell className="pl-3 fw-normal">
                                                                {activitydetails.classId ? activitydetails.classId.className : ''}
                                                            </TableCell>
                                                            <TableCell className="pl-3 fw-normal">
                                                                {activitydetails.studentId ? `${activitydetails.studentId.firstName} ${activitydetails.studentId.lastName}` : ""}
                                                            </TableCell>
                                                            <TableCell className="pl-3 fw-normal">
                                                                {record.superActivityId ? record.superActivityId.superActivityName : "N/A"}
                                                            </TableCell>
                                                            <TableCell className="pl-3 fw-normal">
                                                                {record.activityId ? record.activityId.activityName : "N/A"}
                                                            </TableCell>
                                                            <TableCell className="pl-3 fw-normal">
                                                                {record.subActivityId ? record.subActivityId.subActivityName : "N/A"}
                                                            </TableCell>
                                                            <TableCell className="pl-3 fw-normal">
                                                                {record.remarks}
                                                            </TableCell>
                                                            <TableCell className="pl-3 fw-normal">
                                                                {record.date}
                                                            </TableCell>
                                                            <TableCell className="pl-3 fw-normal">
                                                                {record.key}
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                )
                                            ) : (
                                                <TableRow>
                                                    <TableCell colSpan={8}>No Records</TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                    </TableContainer >
                                </Widget>
                            </Grid>
                        </Grid>
                    
               
        </>
    );
}